import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { App, ConfigProvider } from 'antd';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardLayout from './components/DashboardLayout';
import AboutPage from './pages/AboutPage';
import EventsPage from './pages/EventsPage';
import GalleryPage from './pages/GalleryPage';
import SliderPage from './pages/SliderPage';
import NewsPage from './pages/NewsPage';
import History from './pages/History';
import WhatIsGymkhanaPage from './pages/WhatIsGymkhanaPage';
import ContactPage from './pages/ContactPage';
import MessagesPage from './pages/MessagesPage';
import RegulationsPage from './pages/RegulationsPage';
import ChampionshipStatsPage from './pages/ChampionshipStatsPage';
import DriversPage from './pages/DriversPage';
import CommunityPage from './pages/CommunityPage';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

function AppProvider() {
  return (
    <ConfigProvider>
      <App>
        <AuthProvider>
          <ToastContainer position="top-right" autoClose={3000} />
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard/*"
                element={
                  <PrivateRoute>
                    <DashboardLayout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="slider" element={<SliderPage />} />
                <Route path="news" element={<NewsPage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="events" element={<EventsPage />} />
                <Route path="gallery" element={<GalleryPage />} />
                <Route path="history" element={<History />} />
                <Route path="what-is-gymkhana" element={<WhatIsGymkhanaPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="messages" element={<MessagesPage />} />
                <Route path="regulations" element={<RegulationsPage />} />
                <Route path="championship-stats" element={<ChampionshipStatsPage />} />
                <Route path="drivers" element={<DriversPage />} />
                <Route path="community" element={<CommunityPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </Router>
        </AuthProvider>
      </App>
    </ConfigProvider>
  );
}

export default AppProvider;
